<template>
    <div class="d-flex flex-column flex-root">
        <div class="error-background flex-row-fluid flex-column bgi-size-cover bgi-position-right bgi-no-repeat p-10 p-sm-30">
            <!-- begin:: Content -->
            <h1 class="font-size-sm-100 font-weight-boldest text-dark-75 mt-15" style="font-size: 100px;">
                <slot name="errorTitle"></slot>
            </h1>
            <p class="font-size-h2 font-weight-bold">
                <slot name="errorSubtitle"></slot>
            </p>
            <p class="font-size-h3 font-weight-light">
                <slot name="errorMessage"></slot>
            </p>
            <p class="font-size-h3 font-weight-light pt-5">
                <a href="/">{{$t('homeLinkTitle')}} &gt;</a>
            </p>
            <!-- end:: Content -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ErrorLayout',
    };
</script>

<style scoped>
    .error-background {
        background-image: url('~@/assets/media/error/bg1.jpg');
    }
</style>

<i18n>
    {
        "hr": {
            "homeLinkTitle": "Početna stranica"
        },
        "en": {
            "homeLinkTitle": "Home page"
        }
    }
</i18n>
